@file:OptIn(InternalResourceApi::class)

package gloopgo.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.ScriptQualifier
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/gloopgo.shared.generated.resources/"

@delegate:ResourceContentHash(-1_587_145_851)
internal val Res.string.stats_global_leaderboard: StringResource by lazy {
      StringResource("string:stats_global_leaderboard", "stats_global_leaderboard", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 8723, 52),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 8723, 52),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9339, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9539, 56),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 10667, 72),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 9875, 64),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 8723, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11924, 56),
      ))
    }

@delegate:ResourceContentHash(-1_104_731_077)
internal val Res.string.stats_kills: StringResource by lazy {
      StringResource("string:stats_kills", "stats_kills", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 8776, 31),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 8776, 31),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9400, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9596, 39),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 10740, 31),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 9940, 35),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 8776, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11981, 27),
      ))
    }

@delegate:ResourceContentHash(-1_721_991_401)
internal val Res.string.stats_sp_title: StringResource by lazy {
      StringResource("string:stats_sp_title", "stats_sp_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12009, 50),
      ))
    }

@delegate:ResourceContentHash(-1_024_221_258)
internal val Res.string.stats_title: StringResource by lazy {
      StringResource("string:stats_title", "stats_title", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 8808, 35),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 8808, 35),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9440, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9636, 35),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 10772, 47),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 9976, 47),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 8808, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12060, 35),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString2Resources(map: MutableMap<String, StringResource>) {
  map.put("stats_global_leaderboard", Res.string.stats_global_leaderboard)
  map.put("stats_kills", Res.string.stats_kills)
  map.put("stats_sp_title", Res.string.stats_sp_title)
  map.put("stats_title", Res.string.stats_title)
}
